import React from 'react';
import { Text } from '@components/typography';
import { StyledOL, StyledUnderline } from './RZTermsContent.styles';

export const RZTermsContent: React.FC = () => {
  return (
    <>
      <Text marginTop={[10, 0]} tagName="h1" variant="hed72Hero" color="purple6">
        RACHEL ZOE SWEEPSTAKES
      </Text>
      <Text tagName="h2" variant="dek20" color="purple6">
        OFFICIAL RULES
      </Text>
      <Text marginTop={[6]} tagName="h2" variant="dek20" color="purple6">
        Important: Please read these Official Rules before entering this Sweepstakes (the &quot;Sweepstakes&quot;). By participating in this
        Sweepstakes, you agree to be bound by these Official Rules and represent that you satisfy all of the eligibility requirements below.
      </Text>
      <Text tagName="h3" variant="sectionEyeBrow24" color="purple6">
        NO PURCHASE OR PAYMENT OF ANY KIND IS NECESSARY TO ENTER OR WIN THIS SWEEPSTAKES.
      </Text>
      <Text marginTop={[6]} tagName="p" variant="featureCopy17" color="purple6">
        Sweepstakes void where prohibited by law. Subject to applicablefederal, state, and local laws. This Sweepstakes is directed to
        couples who are engaged to be married and planning to have their wedding [in 2023]. Do not enter if you are already married or not
        engaged to be married [in 2023].
      </Text>
      <StyledOL className="feature-hed-17">
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Eligibility:
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            The Sweepstakes is open only to individuals who (i) are legal residents of the 50 United States or District of Columbia; (ii)
            are at least 18 years old (or the age of majority in their jurisdiction of residence, whichever is older) at the time of entry;
            (iii) are engaged to be married as of the date of entry; and (iv) use a Joy wedding website for the individual&apos;s upcoming
            wedding that will be held in 2023. Directors, officers, members, managers, and employees of Joy, Inc. (&quot;Sponsor&quot;) and
            any of its respective parent companies, affiliate companies, subsidiaries, agents, professional advisors, advertising,
            promotional, public relations, and fulfillment agencies, consultants, legal counsel, website providers, web masters, and
            immediate family members (spouses, parent, child, sibling, grandparent, and/or &quot;step&quot; child, wherever they may live)
            of each are not eligible to win any prize. IF YOU DO NOT MEET ANY OF THESE REQUIREMENTS, OR ANY OTHER ELIGIBILITY REQUIREMENTS
            IN THESE OFFICIAL RULES, YOU ARE NOT ELIGIBLE TO WIN A PRIZE. To be eligible to win a prize, entries must be completed and
            received by Sponsor in the manner and format designated below.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Sweepstakes Period:
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            The Sweepstakes starts at 12:00:01 a.m. (PT) on January 18, 2023 and ends at 11:59:59 p.m. (PT) on February 28, 2023 (the
            &quot;Sweepstakes Period&quot;). All entries must be received during the Sweepstakes Period and meet other requirements in the
            Official Rules to be eligible to win a prize. Sponsor&apos;s computer is the official time-keeping device for the Sweepstakes.
            Proof of submission does not constitute proof of receipt by Sponsor.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            How to Enter:
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            To enter, complete the following steps during the Sweepstakes Period: (1) visit{' '}
            <a href="http://withjoy.com/rachelzoe">http://withjoy.com/rachelzoe</a>; (2) click any &quot;Enter now&quot; link on the page;
            (3) login to your existing account or create an account; (4) if you don&apos;t have one already, create your personal wedding
            website and provide the requested information (e.g., your name and email address); and (5) add at least one item from the Joy
            Shop (<a href="https://withjoy.com/shop/">https://withjoy.com/shop/</a>) to your wedding registry. Once you have completed these
            steps, you will receive one entry into the Sweepstakes.
            <br></br>
            <br></br>
            By entering the Sweepstakes, you consent to being placed on Sponsor&apos;s e-mail mailing list for promotional and other
            purposes.
            <br></br>
            <br></br>
            <StyledUnderline>Limit</StyledUnderline>: ONE ENTRY PER ENGAGED COUPLE DURING SWEEPSTAKES PERIOD. Any attempt to obtain
            additional entries, including through multiple or duplicate accounts may result in disqualification.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Identity of Entrant:
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            All entries must be submitted by the individual entrant. Bulk or automated entries will be disqualified (including entries made
            using any script, macro, bot, or sweepstakes service). Multiple participants are not permitted to share the same email address
            for entry. Any attempt to obtain additional entries through fraud or other illegitimate means will result in disqualification,
            at Sponsor&quot;s discretion
            <br></br>
            <br></br>
            If there is a dispute about the identity of the entrant, entries will be declared made by the authorized account holder of the
            e-mail address submitted or associated with the entry. An &quot;authorized account holder&quot; means the natural person
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Selection and Notification of Winner:
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            On or about March 1, 2023, Sponsor will select the name of the potential winner of the prize in a random drawing from all
            eligible entries. The odds of winning depend on the number of eligible entries received.
            <br></br>
            <br></br>
            Sponsor will notify the potential winner via e-mail on or about March 15th, 2023. To claim a prize, the potential winner must
            follow the instructions contained in the notification. To the fullest extent permitted by applicable law, Sponsor may require
            the potential winner to sign and return, within seven days of being notified, an Affidavit of Eligibility, Liability/Publicity
            Release, and other legal, regulatory, or tax-related document required at Sponsor&apos;s discretion (&quot;Affidavit and Related
            Documents&quot;) in order to claim a prize. If (i) the attempted notification is returned as undeliverable without a forwarding
            address; (ii) the Affidavit and Related Documents are not signed and returned within seven days of the date the notification
            e-mail is sent by Sponsor; or (iii) if the potential winner is otherwise unable to accept the prize as stated, the prize will be
            forfeited and may be awarded to an alternate winner. Alternate drawings will continue until the prize is awarded. If, by reason
            of a print or other error, more prizes are claimed than the number specified in these Official Rules, an alternate winner will
            be selected in accordance with the above selection process from among all valid claimants to award the prize available.
            <br></br>
            <br></br>
            <StyledUnderline>Verification of Potential Winner</StyledUnderline>: THE POTENTIAL WINNER IS SUBJECT TO VERIFICATION BY SPONSOR,
            WHOSE DECISIONS ARE FINAL AND BINDING IN ALL MATTERS RELATED TO THE SWEEPSTAKES. AN ENTRANT IS NOT A PRIZE WINNER UNLESS AND
            UNTIL ENTRANT&apos; ELIGIBILITY HAS BEEN VERIFIED AND ENTRANT HAS BEEN NOTIFIED THAT VERIFICATION IS COMPLETE AND NO FURTHER
            ACTION IS NEEDED.
            <br></br>
            <br></br>
            <StyledUnderline>One Potential Winner per Couple</StyledUnderline>: ONE WINNING COUPLE WILL BE CHOSEN WITH ONLY ONE PERSON
            DESIGNATED AS THE &quot;WINNER.&quot;
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Prize:
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            One winner will receive (i) a stipend of $1,000 for two roundtrip tickets to Los Angeles, CA (Approximate Retail Value
            (&quot;ARV&quot;): $1,000); (ii) a stipend of $1,000 for two nights stay at a hotel of the Sponsor&apos;s choosing (ARV:
            $1,000); (iii) a stipend of $250 for a dinner for two in Los Angeles, CA (ARV: $250); (iv) a stipend of $300 for two treatments
            (e.g., makeup, blowout, haircut, mani and pedi, massage, or facial) of winner&apos;s choosing (ARV: $300); (v) a stipend of
            $5,000 for a pre-wedding styling session with Rachel Zoe that will occur at a date before winner&apos;s wedding, subject to
            Rachel Zoe&apos;s availability (ARV: $5,000); (vi) a stipend of $5,000 for a gifted wedding wardrobe of winner&apos;s choosing
            (ARV: $5,000); (vii) a Nordstrom gift card for $1,000 (ARV: $1,000); and (viii) one $350 gift card to The Shoppe on curateur.com
            (ARV: $350). Total ARV of all prizes: $13,900. Winner must be available between the dates of March 15th, 2023 and July 30th,
            2023 and as selected by the promotion Sponsor, for the pre-wedding styling session with Rachel Zoe.<br></br>
            <br></br>
            Sponsor will provide round trip coach-class airfare for winner and one guest (&quot;Companion&quot;) from an airport close to
            the winner&apos;s home to Los Angeles, California. Sponsor or its designee will determine which airport is closest to the
            winner&apos;s home. Winner and Companion must travel together on the same itinerary. Sponsor will provide ground transportation
            (1) to and from airport and winner&apos;s home and (2) to and from destination airport. Sponsor will provide winner and
            Companion one double-occupancy lodging for two nights at a hotel of the Sponsor&apos;s choosing. Travel arrangements are subject
            to availability and Sponsor&apos;s discretion. Blackout periods and other restrictions, conditions, and/or limitations may
            apply. Air transportation, hotel accommodations, ground transportation, and other elements of prize are determined by Sponsor or
            its designee and must be taken together and cannot be taken separately. Sponsor or its designee will not replace any lost or
            stolen tickets, travel vouchers or certificates or similar items once they are in the winner&apos;s possession.
            <br></br>
            <br></br>
            Any amendment fees or charges incurred due to any changes to the purchased flights are the responsibility of the winner. All
            costs not explicitly specified in these Official Rules are the sole responsibility of the winner, and Sponsor will not provide
            any compensation or reimbursement for these costs, including visa requirements, valid passports, travel insurance, spending
            money, meals, taxes (excluding airline and airport taxes), vaccinations, transfers, items of a personal nature, excess baggage,
            in-room charges, other ancillary costs, and any applicable insurance excesses. Air travel is subject to the airline&apos;s
            conditions of carriage.
            <br></br>
            <br></br>
            To the fullest extent permitted by applicable law, Companion (and, if Companion is under the age majority in his/her
            jurisdiction of residence (a &quot;Minor&quot;), also Companion&apos;s parent or legal guardian) may be required to sign a
            liability/publicity release to be eligible to travel with winner to Los Angeles. To be eligible to travel to Los Angeles,
            California, a Companion that is a Minor must be at least 13 years old and accompanied by his or her parent or legal guardian on
            the trip. Companion (and Companion&apos;s parent or legal guardian if a Minor) agrees to release and indemnify Sponsor pursuant
            to Sections Error! Reference source not found. and Error! Reference source not found., and as otherwise stated in a
            liability/publicity release.
            <br></br>
            <br></br>
            <StyledUnderline>Prize Restrictions</StyledUnderline>: Prize is not transferable. No substitutions or exchanges (including for
            cash) of prize will be permitted, except that Sponsor reserves the right to substitute a prize of comparable or greater value
            for any prize. Only the number of prizes stated in these Official Rules are available to be won in the Sweepstakes. LIMIT ONE
            PRIZE PER COUPLE. Sponsor will not replace any lost or stolen prizes or prize components. Except for applicable
            manufacturer&apos;s standard warranties, the prizes are awarded &quot;AS IS&quot; and WITHOUT WARRANTY OF ANY KIND, express or
            implied (including any implied warranty of merchantability or fitness for a particular purpose). Any unclaimed or unused prize
            (or portion of the prize package) will remain the property of Sponsor
            <br></br>
            <br></br>
            ALL FEDERAL, STATE AND LOCAL TAXES ASSOCIATED WITH THE RECEIPT OR USE OF ANY PRIZE ARE THE SOLE RESPONSIBILITY OF THE WINNER.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Disclaimer
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            Sponsor and any of its respective parent companies, subsidiaries, affiliates, directors, officers, professional advisors,
            consultants, contractors, public relations firms, employees and advertising, fulfillment and marketing agencies, and any of
            their respective directors, officers, members, managers, and employees (collectively, the &quot;Released Parties&quot;) will not
            be responsible for: (a) any late, lost, misrouted, garbled, distorted, or damaged transmissions or entries; (b) phone,
            electronic, hardware, software, network, Internet, or other computer- or communications-related malfunctions or failures; (c)
            any Sweepstakes disruptions, injuries, losses, or damages caused by events beyond the reasonable control of Sponsor or the
            Released Parties; or (d) any printing or typographical errors in any materials associated with the Sweepstakes.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            General Release and Limitations of Liability: By entering the Sweepstakes, you agree to release Sponsor and all Released Parties
            from any liability whatsoever, and waive any and all causes of action, whether under a theory of contract, tort (including
            negligence), warranty or other theory, arising out of or in connection with the Sweepstakes or delivery, misdelivery,
            acceptance, possession, use of, or inability to use, any prize (including claims for costs, losses, personal injuries, death, or
            damages of any kind, such as damage to or destruction of property or damages related to rights of publicity or privacy, moral
            rights, defamation or portrayal in a false light, whether intentional or unintentional).
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL THE SPONSOR OR THE RELEASED PARTIES BE LIABLE FOR ANY
            SPECIAL, INDIRECT, INCIDENTAL, OR CONSEQUENTIAL DAMAGES, INCLUDING LOSS OF USE, LOSS OF PROFITS OR LOSS OF DATA, WHETHER IN AN
            ACTION IN CONTRACT, TORT (INCLUDING NEGLIGENCE) OR OTHERWISE, ARISING OUT OF OR IN ANY WAY CONNECTED TO YOUR PARTICIPATION IN
            THE SWEEPSTAKES OR USE OR INABILITY TO USE ANY EQUIPMENT PROVIDED FOR USE IN THE SWEEPSTAKES OR ANY PRIZE, EVEN IF A RELEASED
            PARTY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
            <br></br>
            <br></br>
            TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL THE AGGREGATE LIABILITY OF THE RELEASED PARTIES (JOINTLY)
            ARISING OUT OF OR RELATING TO YOUR PARTICIPATION IN THE SWEEPSTAKES OR USE OF OR INABILITY TO USE ANY EQUIPMENT PROVIDED FOR USE
            IN THE SWEEPSTAKES OR ANY PRIZE EXCEED $10. THE LIMITATIONS IN THIS SECTION WILL NOT EXCLUDE OR LIMIT LIABILITY FOR PERSONAL
            INJURY OR PROPERTY DAMAGE CAUSED BY PRODUCTS PURCHASED FROM THE SPONSOR, OR FOR THE RELEASED PARTIES&apos; GROSS NEGLIGENCE,
            INTENTIONAL MISCONDUCT, OR FOR FRAUD.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Use of Name, Likeness, etc.:
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            To the fullest extent permitted by applicable law, entry into the Sweepstakes constitutes permission to use your name, hometown,
            biographical data, aural or visual likeness, and prize information for advertising, marketing, and promotional purposes without
            further permission or compensation (including in a public-facing winner list). As a condition of being awarded any prize, except
            where prohibited by law, winner may be required to execute a written consent, confirming Sponsor&apos;s right to use
            winner&apos;s name, hometown, aural or visual likeness, and prize information for advertising, marketing, and promotional
            purposes without further permission or compensation. By entering this Sweepstakes, you consent to being contacted by Sponsor for
            any purpose in connection with this Sweepstakes.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Privacy:
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            Please refer to Sponsor&apos;s Privacy Policy at&nbsp;<a href="https://privacy.withjoy.com">https://privacy.withjoy.com.</a>
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Winner List; Rules Request:
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            For a copy of the winner list, send a stamped, self-addressed, business-size envelope after March 1, 2023 and before April 28th,
            2023 to the address listed in Section 15 below, Attn: Rachel Zoe Sweepstakes. To obtain a copy of these Official Rules
            visit&nbsp;
            <a href="http://withjoy.com/rachelzoe">http://withjoy.com/rachelzoe</a>, or send a stamped, self-addressed business-size
            envelope to the address listed in Section 15 below, Attn: Rachel Zoe Sweepstakes. VT residents may omit return postage.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Intellectual Property:
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            JOY is a trademark of Joy, Inc. The Sweepstakes and all accompanying materials are copyright © 2023 by Joy, Inc. All rights
            reserved.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Disputes:
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            YOU AGREE THAT ANY DISPUTES, CLAIMS, AND CAUSES OF ACTION ARISING OUT OF OR CONNECTED WITH THIS SWEEPSTAKES OR ANY PRIZE AWARDED
            WILL BE RESOLVED INDIVIDUALLY, WITHOUT RESORT TO ANY FORM OF CLASS ACTION, AND EXCLUSIVELY BY THE UNITED STATES DISTRICT COURT
            FOR THE NORTHERN DISTRICT OF CALIFORNIA OR THE APPROPRIATE STATE COURT LOCATED IN SAN FRANCISCO, CALIFORNIA. THESE OFFICIAL
            RULES ARE GOVERNED BY THE LAWS OF THE STATE OF CALIFORNIA, WITHOUT REGARD TO CHOICE OF LAW OR CONFLICT OF LAWS RULES. YOU WAIVE
            ANY AND ALL OBJECTIONS TO JURISDICTION AND VENUE IN THESE COURTS AND HEREBY SUBMIT TO THE JURISDICTION OF THOSE COURTS
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            General Conditions:
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            By participating in the Sweepstakes, you agree to be bound by these Official Rules and by the decisions of Sponsor, which are
            final and binding in all respects. Sponsor reserves the right to change these Official Rules at any time, in its sole
            discretion, and to modify, suspend, or cancel the Sweepstakes or any entrant&apos;s participation in the Sweepstakes should
            viruses, bugs, unauthorized human intervention, pandemics, public disruptions, or other causes beyond Sponsor&apos;s reasonable
            control affect the administration, security, or proper play of the Sweepstakes, or Sponsor otherwise becomes (as determined in
            its sole discretion) incapable of running the Sweepstakes, or Sponsor otherwise becomes (in its discretion) incapable of running
            the Sweepstakes as planned. Entrants who violate these Official Rules, violate any law, rule, or regulation in connection with
            participation in the Sweepstakes, tamper with the operation of the Sweepstakes or engage in any conduct that is detrimental or
            unfair to Sponsor, the Sweepstakes or any other entrant (in each case as determined in Sponsor&apos;s sole discretion) are
            subject to disqualification from entry into the Sweepstakes. Sponsor reserves the right to lock out persons whose eligibility is
            in question or who have been disqualified or are otherwise ineligible to enter the Sweepstakes. Any provision of these Official
            Rules deemed unenforceable will be enforced to the extent permissible, and the remainder of these Official Rules will remain in
            effect. The use of the terms &quot;include&quot; or &quot;including&quot; in these Official Rules is illustrative and not
            limiting. If you have any questions about these Official Rules or the Sweepstakes, please e-mail them to&nbsp;
            <a href="mailto:hello@withjoy.com">hello@withjoy.com</a> or send written questions to the address listed below, Attn: Rachel Zoe
            Sweepstakes.
          </Text>
        </li>
        <li>
          <Text tagName="span" variant="featureHed17" color="purple6">
            Sponsor:
          </Text>
          <Text tagName="span" variant="featureCopy17" color="purple6">
            Joy, Inc., 140 Keller Street #229, Petaluma, CA 94952.
          </Text>
        </li>
      </StyledOL>
    </>
  );
};
